package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.JsonObject

@Serializable
data class FileUploadGrant(
    @SerialName("file_id") val fileId: String? = null,
    @SerialName("record_id") val recordId: String? = null,
    @SerialName("reserved_entity_id") val reservedEntityId: String? = null,
    val status: String? = null,
    val upload: JsonObject = JsonObject(emptyMap())
)

@Serializable
data class FileConfirmResponse(
    @SerialName("file_id") val fileId: String? = null,
    val status: String? = null,
    val message: String? = null
)

@Serializable
data class FileObjectResponse(
    @SerialName("file_id") val fileId: String? = null,
    @SerialName("school_id") val schoolId: String? = null,
    val module: String? = null,
    @SerialName("record_id") val recordId: String? = null,
    @SerialName("object_key") val objectKey: String? = null,
    @SerialName("original_filename") val originalFilename: String? = null,
    @SerialName("declared_mime_type") val declaredMimeType: String? = null,
    @SerialName("detected_mime_type") val detectedMimeType: String? = null,
    @SerialName("size_bytes") val sizeBytes: Long? = null,
    val etag: String? = null,
    val sha256: String? = null,
    val status: String? = null,
    @SerialName("uploaded_by") val uploadedBy: String? = null,
    @SerialName("created_at") val createdAt: String? = null,
    @SerialName("updated_at") val updatedAt: String? = null,
    @SerialName("deleted_by") val deletedBy: String? = null,
    @SerialName("deleted_at") val deletedAt: String? = null,
    val version: Int? = null
)

@Serializable
data class FileDownloadUrlResponse(
    val url: String? = null,
    @SerialName("expires_at") val expiresAt: String? = null
)

@Serializable
data class FileRestoreResponse(
    @SerialName("file_id") val fileId: String? = null,
    val status: String? = null,
    val message: String? = null
)

@Serializable
data class FileListResponse(
    val count: Int? = null,
    val items: List<FileObjectResponse>? = null
)
